import {http} from './config/config-receituario'
export default{
    listar:(token)=>{
        return http.get('centro_custo',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, centroCusto)=>{
        return http.post('centro_custo', centroCusto,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    atualizarCentroCusto:(token, centroCusto) =>{
        return http.put('centro_custo/'+centroCusto.id,centroCusto,{
            headers:{
                'Authorization':token
            }
        })
    }, 
    deleteCentroCusto:(token, id)=>{
        return http.delete('centro_custo/'+id,{
            headers:{
                'Authorization':token
            }
        })
    }
}